import { render, staticRenderFns } from "./DataDialog.vue?vue&type=template&id=2cc14bc2"
import script from "./DataDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports